export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR';
export const RESET_CATEGORIES = 'RESET_CATEGORIES';

export const GET_USER_CATEGORIES = 'GET_USER_CATEGORIES';
export const GET_USER_CATEGORIES_SUCCESS = 'GET_USER_CATEGORIES_SUCCESS';
export const GET_USER_CATEGORIES_ERROR = 'GET_USER_CATEGORIES_ERROR';
export const RESET_USER_CATEGORIES = 'RESET_USER_CATEGORIES';

export const ADD_USER_CATEGORY = 'ADD_USER_CATEGORY';
export const ADD_USER_CATEGORY_SUCCESS = 'ADD_USER_CATEGORY_SUCCESS';
export const ADD_USER_CATEGORY_ERROR = 'ADD_USER_CATEGORY_ERROR';

export const REMOVE_USER_CATEGORY = 'REMOVE_USER_CATEGORY';
export const REMOVE_USER_CATEGORY_SUCCESS = 'REMOVE_USER_CATEGORY_SUCCESS';
export const REMOVE_USER_CATEGORY_ERROR = 'REMOVE_USER_CATEGORY_ERROR';
